import Vue from 'vue';

Vue.filter('length', function (value) {
    if (!value) {
        return 0;
    }
    if (_.isArray(value) || _.isString(value)) {
        return value.length;
    }
    return '';
});

Vue.filter('join', function (arr, opt_separator) {
    if (!arr) {
        return '';
    }
    var separator = opt_separator || '';
    return arr.join(separator);
});

Vue.filter('linebreakToSpace', function (value) {
    if (!value) {
        return '';
    }
    return value.replace(/\r\n/g, '\n').replace(/\n/g, ' ');
});

Vue.filter('formatDate', function (value) {
    if (!value) {
        return '';
    }
    return moment(value).format('YYYY/MM/DD(ddd)');
});

Vue.filter('formatDatetime', function (value) {
    if (!value) {
        return '';
    }
    return moment(value).format('YYYY/MM/DD(ddd) HH:mm');
});
Vue.filter('formatCurrency', function(value) {
    if (!_.isNumber(value)) {
        return value;
    }
    return value.toLocaleString ? value.toLocaleString() : value;
});

Vue.filter('escapeHtml', function(value) {
    if (!value) {
        return value;
    }
    return value.replace(/[&'`"<>]/g, function(match) {
        return {
            '&': '&amp;',
            "'": '&#x27;',
            '`': '&#x60;',
            '"': '&quot;',
            '<': '&lt;',
            '>': '&gt;',
        }[match];
    });
});

Vue.filter('urlize', function(value) {
    if (!value) {
        return value;
    }
    return this.escapeHtml(value).replace(/(https?:\/\/[a-zA-Z0-9-_\.!'()*;/?:@&=+$,%#]+)/gi, '<a href="$1" target="_blank">$1</a>')
});
